/*
 * @File: 法律卡片
 */

import {ubcLog} from '@src/lib/log';
import {Component} from '@src/lib/San';
import {throttle} from '@src/lib/utils/descriptor';
import {showNaToast} from '@src/lib/utils/native';
import {THEME_MODE} from '@src/lib/utils/pageMode';
import {invokeSchema} from '@src/lib/utils/schema';
import $style from './index.module.less';

class CLawCard extends Component {
    static template = /* html */ `
        <div
            class="{{$style.cardContent}} {{isMultipleCard ? $style.multipleCard : ''}}"
            data-law-index="{{index}}"
            on-click="clickCard($event, index)"
        >
            <div class="{{$style.userWrapper}}">
                <div class="{{$style.avatarBox}}">
                    <div class="{{$style.vBg}} {{isDarkTheme ? $style.vBgDark : ''}}"></div>
                    <img class="{{$style.avatar}}" src="{{item.imgUrl}}">
                    <div
                        s-if="item.certificationFlag"
                        class="{{isMultipleCard ? $style.vIcon : $style.singleVIcon}}"
                    >
                    </div>
                </div>
                <div class="{{$style.infoBox}}">
                    <div class="{{$style.nameBox}}">
                        <span class="{{$style.name}}">{{ item.name }}</span>
                        <span class="{{$style.identity}}">{{ item.label }}</span>
                    </div>
                    <div class="{{$style.company}}">
                        {{ item.firm }}
                    </div>
                    <div
                        s-if="!isMultipleCard"
                        class="{{$style.tags}}"
                    >
                        <span
                            s-for="tag in item.tags"
                            class="{{$style.tag}}"
                        >
                            {{ tag }}
                        </span>
                    </div>
                    <div
                        s-if="isMultipleCard"
                        class="{{$style.moreBtn}}"
                    ></div>
                </div>
            </div>
            <div class="{{$style.intro}}">
                {{ item.desc }}
            </div>
            <div
                s-if="!isMultipleCard"
                class="{{$style.askBtn}}"
            >
                {{ item.button }}
            </div>
        </div>
    `;

    initData() {
        return {
            $style,
            // 卡片监听器
            cardObserver: null,
        };
    }

    created() {
        this.watchState(['theme']);
    }

    static computed: Computed = {
        isDarkTheme() {
            const theme = this.data.get('theme');
            return theme === THEME_MODE.Dark;
        },
    };

    @throttle(500)
    clickCard(
        e: Event,
        index: number
    ) {
        e?.stopPropagation();
        const isPcClient = this.store.get('isPcClient');
        if (isPcClient) {
            return showNaToast('暂不支持，请前往文心APP查看消息');
        }
        const scheme = this.data.get('item.scheme');
        this.fire('send-log', {
            type: 'click',
            index,
        });
        if (!scheme) {
            return;
        }
        invokeSchema(scheme);
    }
}

export default class CSugLaw extends Component {
    static template = /* html */ `
        <div
            class="{{$style.cSugCards}}
                {{isHistory ? $style.show : ''}}
                {{visible && !isHistory ? $style.visible : ''}}
                {{checked ? $style.checked : ''}}"
        >
            <div
                class="{{$style.cardBox}}"
            >
                <div s-if="title" class="{{$style.titleTop}}">
                    {{ title }}
                </div>
                <!-- 律临卡(单张、多张支持横滑) -->
                <div class="{{$style.lawWrapper}}">
                    <div class="{{$style.cardList}} {{isMultipleCard ? $style.cardAutoWidth : ''}}">
                        <c-law-card
                            s-for="item, index in sugBots"
                            item="{{item}}"
                            is-multiple-card="{{isMultipleCard}}"
                            index="{{index}}"
                            on-send-log="sendLog"
                        />
                    </div>
                </div>
            </div>
        </div>
    `;

    static components = {
        'c-law-card': CLawCard,
    };

    initData() {
        return {
            $style,
            visible: false,
        };
    }

    attached() {
        setTimeout(() => {
            this.data.set('visible', true);
        }, 10);
        this.nextTick(() => {
            this.setCardObserve();
        });
    }

    static computed: Computed = {
        isMultipleCard() {
            const sugBots = this.data.get('sugBots');
            return sugBots?.length > 1;
        },
    };

    setCardObserve() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0],
        };
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = entry.target?.getAttribute('data-law-index') || 0;
                    this.sendLog({
                        type: 'show',
                        index: +index,
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, options);
        const cardsObserve = this.el?.querySelectorAll('[data-law-index]') || [];
        cardsObserve.length && cardsObserve.forEach(el => observer.observe(el));
        this.data.set('cardObserver', observer);
    }

    // 律师卡片打点
    sendLog(params: {
        type: 'show' | 'click';
        index: number;
    }) {
        const {type, index} = params;
        const sugBots = this.data.get('sugBots');
        if (!sugBots[index]) {
            return;
        }
        // 律师智能体id
        const {id: characterId} = sugBots[index] || {};
        // messageId
        const id = this.data.get('id');
        ubcLog({
            params: {
                page: 'homepage',
                from: 'new_app',
                value: 'law',
                type,
            },
            ext: {
                'character_id': characterId,
                id,
                position: index,
            },
        });
    }

    detached() {
        this.data.get('cardObserver')?.disconnect();
    }
}

